import { style } from '@primeuix/styles/inputgroup';
import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-inputgroup'
};
var InputGroupStyle = BaseStyle.extend({
  name: 'inputgroup',
  style: style,
  classes: classes
});

export { InputGroupStyle as default };
//# sourceMappingURL=index.mjs.map
